import { useEffect, useRef } from "react";
import Header from "../components/header";
import { SmbMain } from "../components/styles/Smb.styled";
import { useNavigate } from "react-router-dom";

const DocusignCallback = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      if (event.data?.type === "resize" && iframeRef.current) {
        iframeRef.current.style.height = event.data.height + "px";
      }
      if (event.data?.type === "SMB_NAVIGATE") {
        navigate(event.data.path);
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const iframeUrl = (() => {
    const url = new URL("https://embed.smb.eiqshopping.com/complete");
    const originalParams = new URLSearchParams(window.location.search);
    originalParams.set("utm-content", "eiqshopping");
    url.search = originalParams.toString();
    return url.toString();
  })();

  return (
    <SmbMain>
      <Header />
      <iframe
        src={iframeUrl}
        width="100%"
        height="100%"
        title="smb-process"
        ref={iframeRef}
        style={{ overflow: "hidden" }}
      />
    </SmbMain>
  );
};

export default DocusignCallback;